import React from 'react';
import { Tag } from 'antd';

const extractIssueNumber = (jira_id) => {
    if (!jira_id) return 0;
    const str = String(jira_id);
    const match = str.match(/(\d+)$/);
    return match ? parseInt(match[1], 10) : 0;
};

export const knownIssuesColumns = (length) => {
    return [
        {
            title: () => {
                return (
                    <>
                        Issue Number <Tag color="processing">{length}</Tag>
                    </>
                );
            },
            dataIndex: 'jira_id',
            key: 'jira_id',
            width: '8%',
            render: (text) => <strong>{text}</strong>,
            sorter: (a, b) => extractIssueNumber(a.jira_id) - extractIssueNumber(b.jira_id),
        },
        {
            title: 'Category',
            dataIndex: 'product_category',
            key: 'product_category',
            width: '15%',
            sorter: (a, b) => (a.product_category ? a.product_category.localeCompare(b.product_category) : 1),
        },
        {
            title: 'Description',
            dataIndex: 'ki_description',
            key: 'ki_description',
            ellipsis: false,
            width: '77%',
            render: (text) => {
                // Remove JIRA/Confluence markup {{ }}
                const cleanText = text?.replace(/\{\{|\}\}/g, '');
                return cleanText;
            },
        },
    ];
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};
